import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import LoadingSpinner from '../../../components/common/LoadingSpinner';
import { loginPathWithNext } from '../../../utils/authRedirect';

const ProtectedStudentRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner size="md" label="Loading…" fullPage />;
  }

  if (!isAuthenticated) {
    const next = `${location.pathname}${location.search || ''}`;
    return <Navigate to={loginPathWithNext(next)} replace />;
  }

  return children;
};

export default ProtectedStudentRoute;
